import { Route } from "react-router";
import { TASKS, TASKS_NOTES } from "@routes/routes";
import { NotesPage, TasksAndNotesPage, TasksPage } from "@routes/lazyPages";

export const taskRoutes = (
  <Route path={TASKS} lazy={TasksAndNotesPage}>
    <Route index lazy={TasksPage} />
    <Route path={TASKS_NOTES} lazy={NotesPage} />
  </Route>
);
